import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { PLP_EVENTS } from 'shared/helpers/analytics/constants/plpEvents';

import NFA from 'shared/helpers/analytics/NFAnalytics';

export const getDynamicCategoryLevels = (product: Listing.IProduct) => {
  try {
    const categoriesData = get(product, 'primary_categories_json_all', {});

    if (isEmpty(categoriesData)) return;

    const names = Object.keys(categoriesData).sort();
    const levels: { [key: string]: string } = {};

    for (let i = 0; i < names.length; i++) {
      levels[`categoryLevel${i + 1}`] = names[i];
    }
    return levels;
  } catch (err) {
    return {};
  }
};

export const onViewSimilarIconClick = (
  itemId: string,
  product: Listing.IProduct,
  isPLPFirstClickInteraction: boolean
) => {
  NFA.track({
    event: PLP_EVENTS.VIEW_SIMILAR_CLICKS,
    data: {
      viewSimilarProductId: product?.id,
      viewSimilarBrandName: product?.title,
      isPLPFirstClickInteraction,
      viewSimilarProductName: product?.subTitle,
      ...getDynamicCategoryLevels(product),
    },
  });
};
